/* src/app/components/lead-details/pace-details/pace-details.component.css */
.ant-picker {
  padding: 0 8px;
  width: 100%;
}
.ant-picker .ant-picker-input {
  border: 2px solid orange !important;
  border-radius: 10%;
}
.ant-picker .ant-picker-input input {
  border: 2px solid red !important;
  border-radius: 10%;
}
::ng-deep .ant-picker-input > input {
  border: none;
}
/*# sourceMappingURL=pace-details.component-K7EIB4SM.css.map */
